import React, { useState, useEffect , useContext} from "react";

import Paper from "@mui/material/Paper";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

import AssistantPhotoIcon from '@mui/icons-material/AssistantPhoto';
import SpeedIcon from "@mui/icons-material/Speed";
import GroupIcon from "@mui/icons-material/Group";
import AssignmentIcon from "@mui/icons-material/Assignment";
import PersonIcon from "@mui/icons-material/Person";
import AssignmentLateIcon from '@mui/icons-material/AssignmentLate';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import { makeStyles } from 'tss-react/mui';
import { grey, blue } from "@mui/material/colors";
import { toast } from "../../services/toast";

import Chart from "./Chart";
import ButtonWithSpinner from "../../components/ButtonWithSpinner";
import SelectUser from "../../components/SelectUser";
import { AuthContext } from "../../context/Auth/AuthContext";


import { Card, CardContent } from "@mui/material";


import CardCounter from "../../components/Dashboard/CardCounter";
import TableAttendantsStatus from "../../components/Dashboard/TableAttendantsStatus";
import { isArray } from "lodash";

import useDashboard from "../../hooks/useDashboard";
import useCompanies from "../../hooks/useCompanies";

import QueueSelect from "../../components/QueueSelect";


import { isEmpty } from "lodash";
import moment from "moment";

const useStyles = makeStyles()((theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  fixedHeightPaper: {
    padding: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    height: 240,
    overflowY: "auto",
    ...theme.scrollbarStyles,
  },
  cardAvatar: {
    fontSize: "55px",
    color: grey[500],
    backgroundColor: "#ffffff",
    width: theme.spacing(7),
    height: theme.spacing(7),
  },
  cardTitle: {
    fontSize: "18px",
    color: blue[700],
  },
  cardSubtitle: {
    color: grey[600],
    fontSize: "14px",
  },
  alignRight: {
    textAlign: "right",
  },
  fullWidth: {
    width: "100%",
  },
  selectContainer: {
    width: "100%",
    textAlign: "left",
  },
}));

const Dashboard = () => {
  const { classes } = useStyles();
  const [counters, setCounters] = useState({});
  const [attendants, setAttendants] = useState([]);
  const [period, setPeriod] = useState(0);
  const [companyDueDate, setCompanyDueDate] = useState();
  const [dateFrom, setDateFrom] = useState(moment().format("YYYY-MM-DD"));
  const [dateTo, setDateTo] = useState(moment().format("YYYY-MM-DD"));  
  const [loading, setLoading] = useState(false);
  const { user } = useContext(AuthContext);
  const [selectedUser, setSelectedUser] = useState(user.id);
  const [selectedQueueIds, setSelectedQueueIds] = useState([]);




  const { find } = useDashboard();
  const { finding } = useCompanies();
  useEffect(() => {
    async function firstLoad() {
      await fetchData();
    }
    setTimeout(() => {
      firstLoad();
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  async function fetchData() {
    setLoading(true);

    let params = {};


    if (selectedUser !== '') {
      params = {
        ...params,
        userId: selectedUser
      };
    }

    


    if (!isEmpty(selectedQueueIds)) {
      params = {
        ...params,
        queueIds: selectedQueueIds,
      };
    }

    if (period > 0) {
      params = {
        days: period,
      };
    }

    if (!isEmpty(dateFrom) && moment(dateFrom).isValid()) {
      params = {
        ...params,
        date_from: moment(dateFrom).format("YYYY-MM-DD"),
      };
    }

    if (!isEmpty(dateTo) && moment(dateTo).isValid()) {
      params = {
        ...params,
        date_to: moment(dateTo).format("YYYY-MM-DD"),
      };
    }

    if (Object.keys(params).length === 0) {
      toast.error("Parametrizar el filtro");
      setLoading(false);
      return;
    }

    const data = await find(params);


    setCounters(data.counters);
    if (isArray(data.attendants)) {
      setAttendants(data.attendants);
    } else {
      setAttendants([]);
    }

    setLoading(false);
  }

  useEffect(() => {
    async function fetchData() {
      await loadCompanies();
    }
    fetchData();
  }, [])
  const companyId = localStorage.getItem("companyId");
  const loadCompanies = async () => {
    setLoading(true);
    try {
      const companiesList = await finding(companyId);
      setCompanyDueDate(moment(companiesList.dueDate).format("DD/MM/yyyy"));
    } catch (e) {
      console.log("Dev. Luigy Miranda.", e);
    }
    setLoading(false);
  };

  function formatTime(minutes) {
    return moment()
      .startOf("day")
      .add(minutes, "minutes")
      .format("HH[h] mm[m]");
  }


  const porcentaje = (counters.supportFinished / counters.supportTotal) * 100;


  return (
    <div>
      <Container maxWidth="lg" className={classes.container}>
        <Card style={{ marginBottom: '2%' }}>
          <CardContent style={{ display: 'flex' }}>

            <Grid
              style={{ marginRight: '10px'}}
              size={{
                xs: 12,
                sm: 6,
                md: 6
              }}>
              <QueueSelect
                  selectedQueueIds={selectedQueueIds}
                  onChange={(selectedIds) => setSelectedQueueIds(selectedIds)}
                />
            </Grid>

            <Grid
              style={{ marginRight: '10px'}}
              size={{
                xs: 12,
                sm: 6,
                md: 2
              }}>
              <SelectUser
                selectUserid={selectedUser}
                companyId={companyId}
                onChange={(values) => setSelectedUser(values)}
                disabled={user.profile === "user"} 
              />

            </Grid>
            <Grid
              style={{ marginRight: '10px'}}
              size={{
                xs: 12,
                sm: 6,
                md: 2
              }}>
              <TextField
                label="Desde"
                type="date"
                value={dateFrom}
                onChange={(e) => setDateFrom(e.target.value)}
                className={classes.fullWidth}
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  }
                }}
              />
            </Grid>
            <Grid
              style={{ marginRight: '10px'}}
              size={{
                xs: 12,
                sm: 6,
                md: 2
              }}>
              <TextField
                label="Hasta"
                type="date"
                value={dateTo}
                onChange={(e) => setDateTo(e.target.value)}
                className={classes.fullWidth}
                slotProps={{
                  inputLabel: {
                    shrink: true,
                  }
                }}
              />
            </Grid>

            <Grid className={classes.alignRight} style={{alignSelf: 'center'}} size={2}>
              <ButtonWithSpinner
                loading={loading}
                onClick={() => fetchData()}
                variant="contained"
                color="primary"
              >
                Filtrar
              </ButtonWithSpinner>
            </Grid>
          </CardContent>
        </Card>

        <Grid container spacing={3} sx={{
          justifyContent: "flex-end"
        }}>
        <Grid
          size={{
            xs: 12,
            sm: 6,
            md: 3
          }}>
            <CardCounter
              icon={<AssistantPhotoIcon fontSize="inherit" />}
              title="Total"
              value={ counters.supportTotal}
              loading={loading}
            />
          </Grid>


          <Grid
            size={{
              xs: 12,
              sm: 6,
              md: 3
            }}>
            <CardCounter
              icon={<AssignmentLateIcon fontSize="inherit" />}
              title="Pendientes"
              value={counters.supportPending}
              loading={loading}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6,
              md: 3
            }}>
            <CardCounter
              icon={<AssignmentIcon fontSize="inherit" />}
              title="Trabajando"
              value={counters.supportHappening}
              loading={loading}
            />
          </Grid>
          
          <Grid
            size={{
              xs: 12,
              sm: 6,
              md: 3
            }}>
            <CardCounter
              icon={<AssignmentTurnedInIcon fontSize="inherit" />}
              title="Cerrados"
              value={`${counters.supportFinished} / (${porcentaje.toFixed(2)}%)`}
              loading={loading}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6,
              md: 3
            }}>
            <CardCounter
              icon={<PersonIcon fontSize="inherit" />}
              title="Chats Auditados"
              value={counters.supportAuditor}
              loading={loading}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6,
              md: 3
            }}>
            <CardCounter
              icon={<PersonIcon fontSize="inherit" />}
              title="Contactos nuevos"
              value={counters.leads}
              loading={loading}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6,
              md: 3
            }}>
            <CardCounter
              icon={<SpeedIcon fontSize="inherit" />}
              title="Atención al cliente"
              value={formatTime(counters.avgSupportTime)}
              loading={loading}
            />
          </Grid>
          <Grid
            size={{
              xs: 12,
              sm: 6,
              md: 3
            }}>
            <CardCounter
              icon={<SpeedIcon fontSize="inherit" />}
              title="Espera al cliente"
              value={formatTime(counters.avgWaitTime)}
              loading={loading}
            />
          </Grid>
          <Grid size={12}>
            <Paper className={classes.fixedHeightPaper}>
              <Chart />
            </Paper>
          </Grid>
          <Grid size={12}>
            {attendants.length ? (
              <TableAttendantsStatus
                attendants={attendants}
                loading={loading}
              />
            ) : null}
          </Grid>
        </Grid>
      </Container>
    </div>
  );
};

export default Dashboard;
